<div>
  <kendo-grid [kendoGridBinding]="gridView" [pageable]="true" [pageSize]="gridState.take" [skip]="gridState.skip"
    [scrollable]="'true'" [sortable]="true" [resizable]="true" [filter]="gridState.filter" [sort]="gridState.sort">

    <!-- MOBILE VIEW -->
    <kendo-grid-column media="(max-width: 772.98px)" title="Details">
      <ng-template kendoGridCellTemplate let-dataItem>
        <dl>
          <dd>
            <div class="align-left">
              <span class="bold">Fiscal Year: </span>
              <span> {{ dataItem.fiscalYear }}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">PPED: </span>
              <span> {{ dataItem.payPeriodEndDate | date: 'MM/dd/yyyy'}}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">Contribution: </span>
              <span [ngClass]=" 0 > dataItem.employeeContribution ? 'neg-amount' : ''">
                {{ dataItem.formatAmount }}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">HW: </span>
              <span> {{ dataItem.hoursWorked}}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">SH: </span>
              <span> {{ dataItem.standardHours}}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">PCT: </span>
              <span> {{ dataItem.percentFullTime}}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">AAComp: </span>
              <span> {{ dataItem.actualAnnualCompensation | currency:'USD':'symbol':'1.0-2'}}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">AEComp: </span>
              <span> {{ dataItem.actualEarnableCompensation | currency:'USD':'symbol':'1.0-2'}}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">Reason Code: </span>
              <span> {{ dataItem.reasonCodes}}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">Warning: </span>
              <span class="text-red" *ngIf="dataItem.issue" title={{dataItem.issue}}><span
                  class="k-icon k-i-warning text-red"></span></span>
            </div>
          </dd>
          <dd *ngIf="isReview">
            <div class="align-left">
              <span class="bold">Review: </span>
              <span class="text-warning" *ngIf="dataItem.review" title="Under Review"><span
                  class="k-icon k-i-track-changes-reject text-warning"></span></span>
            </div>
          </dd>
        </dl>
      </ng-template>
    </kendo-grid-column>

    <!-- FISCAL YEAR -->
    <kendo-grid-column media="(min-width: 773px)" field="fiscalYear" title="Fiscal Year" [width]="100"
      [headerClass]="{'align-date': true}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-date">
          <span>
            {{dataItem.fiscalYear}}
          </span>
        </div>
      </ng-template>
    </kendo-grid-column>

    <!-- PPED -->
    <kendo-grid-column media="(min-width: 773px)" field="payPeriodEndDate" title="PPED" [width]="100"
      [headerClass]="{'align-date': true}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-date">
          <a (click)="openRecord(dataItem, true)" class="clone-link">
            {{dataItem.payPeriodEndDate | date: 'MM/dd/yyyy'}}
          </a>
        </div>
      </ng-template>
    </kendo-grid-column>

    <!-- EMP CONTRIBUTION -->
    <kendo-grid-column media="(min-width: 773px)" field="employeeContribution" title="Contribution" [width]="110"
      [headerClass]="{'align-number': true}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-number">
          <span [ngClass]=" 0 > dataItem.employeeContribution ? 'neg-amount' : ''">
            {{dataItem.formatAmount}}
          </span>
        </div>
      </ng-template>
    </kendo-grid-column>

    <!-- HOURS WORKED -->
    <kendo-grid-column media="(min-width: 773px)" field="hoursWorked" title="HW" [width]="60" format="{0:n1}"
      [headerClass]="{'align-number': true}" class="align-number">
    </kendo-grid-column>

    <!-- STANDARD HOURS -->
    <kendo-grid-column media="(min-width: 773px)" field="standardHours" title="SH" [width]="60" format="{0:n1}"
      [headerClass]="{'align-number': true}" class="align-number">
    </kendo-grid-column>

    <!-- PCT -->
    <kendo-grid-column media="(min-width: 773px)" field="percentFullTime" title="PCT" [width]="60" format="{0:n0}"
      [headerClass]="{'align-number': true}" class="align-number"></kendo-grid-column>

    <!-- AAC -->
    <kendo-grid-column media="(min-width: 773px)" field="actualAnnualCompensation" title="AAComp" [width]="100"
      [headerClass]="{'align-number': true}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-number">{{dataItem.actualAnnualCompensation | currency:'USD':'symbol':'1.0-2'}}</div>
      </ng-template>
    </kendo-grid-column>

    <!-- AEC -->
    <kendo-grid-column media="(min-width: 773px)" field="actualEarnableCompensation" title="AEComp" [width]="100"
      [headerClass]="{'align-number': true}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-number">{{dataItem.actualEarnableCompensation | currency:'USD':'symbol':'1.0-2'}}</div>
      </ng-template>
    </kendo-grid-column>

    <!-- WARNING STATUS -->
    <kendo-grid-column media="(min-width: 773px)" field="warning" title="Warning"
      [headerStyle]="{'text-align': 'center'}" [width]="100" [filterable]="false">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div class="align-center">
          <span class="text-warning" *ngIf="dataItem.issue" title={{dataItem.issue}}><span
              class="k-icon k-i-warning text-warning"></span></span>
        </div>
      </ng-template>
    </kendo-grid-column>

    <!-- REVIEW STATUS -->
    <kendo-grid-column media="(min-width: 773px)" field="review" title="Review" *ngIf="isReview"
      [headerStyle]="{'text-align': 'center'}" [width]="80" [filterable]="false">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div class="align-center">
          <span class="text-warning" *ngIf="dataItem.review" title='Under Review'><span
              class="k-icon k-i-track-changes-reject text-warning"></span></span>
        </div>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>

  <div *ngIf="isClicked">
    <app-record-detail-view [adjRecordDetail]="adjRecord" (isCancelClicked)="isDialogClosed($event)">
    </app-record-detail-view>
  </div>
</div>
